import React from 'react';
import { Handle, Position } from 'reactflow';

// این گره برای نمایش صفحه مقصد با چندین نقطه اتصال ورودی طراحی شده است
const TargetPageNode = ({ data }) => {
  // ایجاد یک آرایه از هندل‌ها بر اساس تعداد لینک‌های ورودی
  const handles = Array.from({ length: data.linkCount || 1 }, (_, i) => (
    <Handle
      key={`handle-${i}`}
      type="target"
      position={Position.Left}
      id={`handle-${i}`} // ID منحصر به فرد برای هر هندل
      style={{ top: `${(100 / (data.linkCount + 1)) * (i + 1)}%` }} // توزیع عمودی هندل‌ها
    />
  ));

  return (
    <div className="node-page">
      {handles}
      {data.label}
    </div>
  );
};

export default TargetPageNode;